export const AnalyticsPermissions = {
  default: 'User.RiskMonitoring.Analytics',
  consolidated: 'User.RiskMonitoring.Analytics.ConsolidatedTraderAnalytics',
  excel: 'User.RiskMonitoring.Analytics.Excel',
} as const;
